import React, { Component } from "react";
import QrReader from "react-qr-scanner";

class LegacyModeExample extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.showthescanner = this.showthescanner.bind(this);
  }

  handleError(err) {
    console.error(err);
  }
  showthescanner() {
    console.log(this.refs.qrReader1);
    this.refs.qrReader1.openImageDialog();
  }

  render() {
    let isDesktop = this.props.width > 768;
    return (
      <div>
        <QrReader
          ref="qrReader1"
          chooseDeviceId={this.props.cameraID}
          delay={1000}
          style={{
            height: "auto",
            width: "100%",
          }}
          legacyMode={true}
          //   onError={e=>{if(e){console.log(e)}}}
          //   onLoad={e=>{if(e){console.log(e)}}}
          onScan={(e) => {
            this.props.onScan(e);
          }}
          constraints={
            isDesktop
              ? undefined
              : {
                  video: {
                    facingMode: { exact: `environment` },
                  },
                }
          }
        />
        {/* <input type="button" value="Scan QR " onClick={()=>{this.showthescanner()}} /> */}
      </div>
    );
  }
}

export default LegacyModeExample;
